import { CheckBox } from 'devextreme-react/check-box';
import React, { FC, Fragment } from 'react';
import { LicensePlateItem } from 'services/types';
import './license-plate-checkbox.scss';
import notify from 'devextreme/ui/notify';


type Props = {
    lpItem: LicensePlateItem,
    isCheckBoxDisabled?: boolean,
    onLpSelected: (lpItem: LicensePlateItem, isChecked: boolean) => void
}

export const LicensePlateCheckbox: FC<Props> = ({ lpItem, isCheckBoxDisabled = false, onLpSelected }) => {

    return (
        <Fragment>
            {lpItem &&
                <div className={'license-plate-checkbox'}>
                    <div className={`verify-item-license-plate-${lpItem.isVerified ?? false}`}>{`${lpItem.licensePlateId} (${lpItem.shippedQuantity})`}</div>
                    
                    <div onClick={isCheckBoxDisabled ? () => notify('All of the catch weight items must be verified', 'info', 3000) : undefined}>
                        <CheckBox visible={true} disabled={isCheckBoxDisabled} value={lpItem.isVerified ?? false} onValueChanged={e => onLpSelected(lpItem, e.value)} />
                    </div>
                </div>
            }
        </Fragment>
    )
}